// extracted by mini-css-extract-plugin
export default {"badge":"Badge_badge__35lIH","officiel":"Badge_officiel__6Jmkm","foedselsdag":"Badge_foedselsdag__wkI5A","maerkedag":"Badge_maerkedag__NZrsx"};